var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 5,
    fill: "#E8E2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 28.92V31.92C34.0011 32.1985 33.944 32.4741 33.8324 32.7293C33.7209 32.9845 33.5572 33.2136 33.352 33.4018C33.1468 33.5901 32.9045 33.7335 32.6407 33.8227C32.3769 33.9119 32.0973 33.945 31.8199 33.92C28.7428 33.5856 25.7869 32.5341 23.1899 30.85C20.7738 29.3146 18.7253 27.2661 17.1899 24.85C15.4999 22.2412 14.4482 19.271 14.1199 16.18C14.0949 15.9034 14.1278 15.6247 14.2164 15.3616C14.3051 15.0985 14.4475 14.8567 14.6347 14.6516C14.8219 14.4465 15.0497 14.2827 15.3037 14.1705C15.5577 14.0583 15.8323 14.0002 16.1099 14H19.1099C19.5952 13.9952 20.0657 14.1671 20.4337 14.4835C20.8017 14.8 21.042 15.2394 21.1099 15.72C21.2366 16.68 21.4714 17.6227 21.8099 18.53C21.9445 18.8879 21.9736 19.2769 21.8938 19.6509C21.8141 20.0248 21.6288 20.3681 21.3599 20.64L20.0899 21.91C21.5135 24.4135 23.5864 26.4864 26.0899 27.91L27.3599 26.64C27.6318 26.3711 27.9751 26.1858 28.3491 26.1061C28.723 26.0263 29.112 26.0554 29.4699 26.19C30.3772 26.5285 31.3199 26.7634 32.2799 26.89C32.7657 26.9585 33.2093 27.2032 33.5265 27.5775C33.8436 27.9518 34.0121 28.4296 33.9999 28.92Z",
    stroke: "#8A6CC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.2a09af882dd722259a25f8e1ec69839d.svg";
export { ForwardRef as ReactComponent };